import { render, staticRenderFns } from "./visitLogDetail.vue?vue&type=template&id=ac4e78f6&"
import script from "./visitLogDetail.vue?vue&type=script&lang=js&"
export * from "./visitLogDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports